module.exports = __webpack_public_path__ + "static/img/1.6944b1d5.png";